export const REMINDER_SCROLL_PARAM = "scrollTo";
export const REMINDER_SCROLL_VALUE = "reminders";
export const REMINDER_ID_PARAM = "reminderId";

export const REMINDERS_SECTION_ANCHOR_ID = "reminders-section";

export const reminderRowAnchorId = (id: number | string): string =>
	`reminder-row-${id}`;
